import React from "react";

const SchedulingQuestions = () => {
    const helpLineNo = '833.466.3020';
    return <div className="scheduling-questions">
        <h6 className="schedule-question-text">Have scheduling questions?
                <span>
                {" "}Call <a className="phone-link" href={"tel:" + helpLineNo}>{helpLineNo}</a>
            </span>
        </h6>
    </div>
}

export default SchedulingQuestions